import { Component } from '@angular/core';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'logo-header',
    template: require('./../../templates/common/logoHeader.component.html'),
    styles: [require('./../../styles/common/logoHeader.component.css')],
    providers: [TranslationService]
})
export class LogoHeaderComponent {
    logoText: string;

    constructor(private translationService: TranslationService) {

    }

    ngOnInit() {
        this.initTranslations();
    }

    initTranslations() {
        this.translationService.translate('instance.logoText', '', (data) => this.logoText = data);
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/logoHeader.component.ts